module.exports = __webpack_public_path__ + "img/贯叶金丝桃.d913924b.jpg";